import { TReaderBlock } from '@app-evolution-cms/email-builder';

export function isAvatarBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Avatar' } {
  return block?.type === 'Avatar';
}

export function isDividerBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Divider' } {
  return block?.type === 'Divider';
}

export function isContainerBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Container' } {
  return block?.type === 'Container';
}

export function isColumnsContainerBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'ColumnsContainer' } {
  return block?.type === 'ColumnsContainer';
}

export function isButtonBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Button' } {
  return block?.type === 'Button';
}

export function isImageBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Image' } {
  return block?.type === 'Image';
}

export function isHtmlBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Html' } {
  return block?.type === 'Html';
}

export function isSpacerBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Spacer' } {
  return block?.type === 'Spacer';
}

export function isHeadingBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Heading' } {
  return block?.type === 'Heading';
}

export function isTextBlock(
  block: TReaderBlock | undefined,
): block is TReaderBlock & { type: 'Text' } {
  return block?.type === 'Text';
}
